<template>
  <div class="section-separator"
     :class="{'with-border border-b border-gray-200': hasBorder, 'mt-0': noMarginTop, [`size-${size}`]: size}">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'section-separator',
    props: {
      hasBorder: Boolean,
      noMarginTop: Boolean,
      size: {
        type: String,
        default: ''
      }
    }
  }
</script>
<style lang="scss">
  .section-separator {
    @apply text-lg leading-6 font-medium text-gray-900 mt-6;

    &.with-border {
      margin-bottom: 15px;
      padding-bottom: 10px;
    }
    &.size-lg {
      font-size: 18px;
      text-transform: initial;
      margin-top: 25px;
    }
  }
  .second-sidebar .section-separator {
    @apply ml-1 mb-1 text-sm uppercase font-semibold text-gray-700;
  }
</style>
